import React, { useState } from "react";
import { Accordion, AccordionSummary, AccordionDetails, Typography, Button } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CreatingIndents from "./CreatingIndents";
import CreatingIndentStageTwo from "./CreatingIndentStageTwo";
import CreatingIndentStageThree from "./CreatingIndentStageThree";
import { IndentData, IndentFormData } from "../types/assetTypes";

interface EditIndentsProps {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  indentId: number | null;
  mode?: "create" | "edit";
  setIndentId: React.Dispatch<React.SetStateAction<number | null>>;
  indentPrimaryId: number | null;
  setIndentPrimaryId: React.Dispatch<React.SetStateAction<number | null>>;
  userId: number;
  setSelectedStage: React.Dispatch<React.SetStateAction<string>>;
  submittedPayload: IndentFormData | null;
  setSubmittedPayload: React.Dispatch<React.SetStateAction<IndentFormData | null>>;
  editData?: IndentData; 
  stage1Data?: IndentData | null;
  stage2Data?: IndentData | null;
  stage3Data?: IndentData | null;
  setEditOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  setIsEdit?: React.Dispatch<React.SetStateAction<boolean>>;
}

const EditIndents: React.FC<EditIndentsProps> = ({
  stage1Data,
  stage2Data,
  stage3Data,
  setEditOpen,
  setIsEdit,
  setOpen,
  editData,
  indentId,
  mode = "edit",
  setIndentId,
  indentPrimaryId,
  setIndentPrimaryId,
  userId,
  setSubmittedPayload,
  submittedPayload,
  setSelectedStage
}) => {
  // Track expanded state for each stage independently
  const [expandedStages, setExpandedStages] = useState<{ [key: string]: boolean }>({
    stage1: false,
    stage2: false,
    stage3: false,
  });
  

  const handleAccordionChange = (stage: string) => (_event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpandedStages(prev => ({
      ...prev,
      [stage]: isExpanded,
    }));
  };

  return (
    <div style={{ padding: 16, maxWidth: "1200px", margin: "0 auto" }}>
      
      {stage1Data && (
        <Accordion expanded={expandedStages.stage1} onChange={handleAccordionChange("stage1")}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            {!expandedStages.stage1 && <Typography>Stage 1</Typography>}
          </AccordionSummary>
          <AccordionDetails>
            <CreatingIndents
              setOpen={setOpen}
              mode={mode}
              editData={stage1Data}
              setEditOpen={setEditOpen}
              setIndentId={setIndentId}
              setIndentPrimaryId={setIndentPrimaryId}
              userId={userId}
              indentId={indentId}
              indentPrimaryId={indentPrimaryId}
              setSelectedStage={setSelectedStage}
              setSubmittedPayload={setSubmittedPayload}
              submittedPayload={submittedPayload}
            />
          </AccordionDetails>
        </Accordion>
      )}

      {stage2Data && (
        <Accordion expanded={expandedStages.stage2} onChange={handleAccordionChange("stage2")}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            {!expandedStages.stage2 && <Typography>Stage 2</Typography>}
          </AccordionSummary>
          <AccordionDetails>
            <CreatingIndentStageTwo
              setOpen={setOpen}
              setEditOpen={setEditOpen}
              editData={stage2Data}
              setIndentId={setIndentId}
              setIndentPrimaryId={setIndentPrimaryId}
              userId={userId}
              indentId={indentId}
              indentPrimaryId={indentPrimaryId}
              setSelectedStage={setSelectedStage}
              setSubmittedPayload={setSubmittedPayload}
              submittedPayload={submittedPayload}
            />
          </AccordionDetails>
        </Accordion>
      )}

      {stage3Data && (
        <Accordion expanded={expandedStages.stage3} onChange={handleAccordionChange("stage3")}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            {!expandedStages.stage3 && <Typography>Stage 3</Typography>}
          </AccordionSummary>
          <AccordionDetails>
            <CreatingIndentStageThree
              setOpen={setOpen}
              setEditOpen={setEditOpen}
              editData={stage3Data}
              setIndentId={setIndentId}
              setIndentPrimaryId={setIndentPrimaryId}
              userId={userId}
              indentId={indentId}
              indentPrimaryId={indentPrimaryId}
              setSelectedStage={setSelectedStage}
              setSubmittedPayload={setSubmittedPayload}
              submittedPayload={submittedPayload}
            />
          </AccordionDetails>
        </Accordion>
      )}

      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
        <Button
          variant="contained"
          color="secondary"
          size="small"          
          onClick={() => {
            setEditOpen && setEditOpen(false); // close edit page
            setOpen && setOpen(false);         // close dialog if exists (create mode)
            setIsEdit && setIsEdit(false);
          }}
        >
          Close
        </Button>
      </div>

    </div>
  );
};

export default EditIndents;
